<div id="accessorio">
    <div *ngIf="accessorioSelezionato">
        <nav>
            <ul class="nav-wrapper"  *ngIf="!ricerca">
                <li><a mat-raised-button color="primary" [routerLink]="['/accessori']">{{'Accessori'|translate}}</a></li><li *ngIf="accessorioSelezionato"><span>&raquo;</span><a  mat-raised-button color="accent">{{accessorioSelezionato.descrizione}}</a></li>
            </ul>
        </nav>
        <div fxLayout="row wrap" fxLayoutAlign="none stretch">

            <mat-card class="testata">
                <div class="img bgfix" [ngStyle]="{'background-image': 'url(' + accessorioSelezionato.img + ')'}">
            </div>
            <div class="testata-centro">
                <h1>{{ accessorioSelezionato.descrizione}}</h1>
                <mat-card-title class="line-breaker">{{ accessorioSelezionato.testo}}</mat-card-title>
                <mat-card-title><span>{{'Cod.'|translate}}</span> {{accessorioSelezionato.codice}}</mat-card-title>

                <mat-card-subtitle *ngIf="utente && utente.prezzi">{{'Prezzo €'|translate}} {{ accessorioSelezionato.prezzo }}</mat-card-subtitle>

                <mat-card-content *ngIf="utente && utente.carrello">
                    <div class="qta" *ngIf="utente && utente.qta">
                     <span>{{'Qta'|translate}} </span><input [(ngModel)]="accessorioSelezionato.qta" name="qta_{{accessorioSelezionato.id}}" type="number" min="0" step="1" size="2" />
                    </div><button (click)="aggiungiCarrello(accessorioSelezionato)" mat-raised-button color="bottonebianco" >{{'Aggiungi al carrello'|translate}}</button>
                    <!--a class="carrello" (click)="aggiungiCarrello(accessorioSelezionato)"><i class="material-icons">&#xE854;</i></a-->

                </mat-card-content>
            </div>
        </mat-card>

        <mat-card class="accessori-documentazione">

            <h3 mat-subheader>{{'Documentazione'|translate}}</h3>
            <div *ngIf="!accessorioSelezionato.documenti || accessorioSelezionato.documenti.length<1" class="risultati">
                {{'Nessun documento trovato'|translate}}
        </div>
        <table *ngIf="accessorioSelezionato.documenti && accessorioSelezionato.documenti.length>0" class="mat-data-table" cellpadding="0" cellspacing="0" width="100%" >
            <thead>
                <tr>

                    <th class="mdl-data-table__cell--non-numeric" width="80%">
                        <span>{{'Tipo documento'|translate}} </span>
                    </th>
                    <th class=" right mdl-data-table__cell--non-numeric">
                        <span>Dim.</span>
                    </th><th></th>

                </tr>
            </thead>
            <tbody>
                <tr grid-item *ngFor="let f of accessorioSelezionato.documenti">
                    <td><a target="_blank" href="{{f.url}}" class="nowrap">{{f.descrizione}}</a></td>
                    <td class="prezzo">{{f.size}}</td>
                    <td><a target="_blank" href="{{f.url}}"><i class="material-icons">&#xE884;</i></a></td>
                </tr>
            </tbody>
        </table>
    </mat-card>

</div>
</div>
<div *ngIf="accessorioSelezionato && accessorioSelezionato.macchine && accessorioSelezionato.macchine.length>0" class="accessorio-macchine">
    <h4 class="titologriglia">{{'Macchine compatibili'|translate}}</h4>
    <div class="macchine" fxLayout="row wrap" fxLayoutAlign="none stretch">
        <div *ngFor="let m of  accessorioSelezionato.macchine" class="card">
            <mat-card >
                <div class="content">
                    <mat-card-header>
                        <mat-card-title>{{ m.nome }}</mat-card-title>
                        <mat-card-subtitle>{{ m.descrizione }}</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>

                        <a [routerLink]="['/scheda', m.id]"><div class="img bgfix" [ngStyle]="{'background-image': 'url(' + m.img + ')'}">
                                                                 <!--img src="{{ m.img }}"-->
                        </div></a>
                    <p class="codice">{{'Cod.'|translate}}<a [routerLink]="['/scheda', m.id]">{{ m.codice }}</a></p>
                </mat-card-content>
                <mat-card-actions class="destra">
                    <button [routerLink]="['/scheda', m.id]" mat-raised-button color="bottonebianco" >{{'Scheda'|translate}}</button>
                </mat-card-actions>
            </div>
        </mat-card>
    </div>
</div>
</div>
<div *ngIf="accessorioSelezionato && accessorioSelezionato.galleria_immagini && accessorioSelezionato.galleria_immagini.length>0" class="accessorio-gallery">
    <h4 class="titologriglia">{{'Foto gallery'|translate}}</h4>
    <div class="gallery" fxLayout="row wrap" fxLayoutAlign="none stretch">
        
            <mat-card *ngFor="let m of  accessorioSelezionato.galleria_immagini">
                <img mat-card-image src="{{m.path}}" alt="{{m.filename}}">
                <mat-card-content *ngIf="m.label">
                        {{m.label}}
                </mat-card-content>
            </mat-card>
        
    </div>
</div>


</div>


// WEBPACK FOOTER //
// ./src/app/tws-accessorio/tws-accessorio.component.html